import { Link } from 'react-router-dom';

import { getInfo, NameAndLabelFormatter } from '@Components/Grid/components/Table/formatters';
import { formatDate } from '@Utils/index';

export default function ReporterFormatter({ info }) {
  const { row } = getInfo(info)
  const { id: userId, first_name, last_name } = row.user || {}

  return <NameAndLabelFormatter
    title={<Link className='hover:underline' to={`/admin/users/${userId}`}> {`[#${userId}] - ${first_name} ${last_name}`} </Link>}
    subtitle={`Reported at: ${formatDate(row.createdAt, 'MMM DD, YYYY - hh:mm A')}`} />
}
